export default "__VITE_ASSET__DsfkY$EM__"